import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ReferralService } from 'src/app/core/services/referral.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralLinkResolver  {
  constructor(
    private referralService: ReferralService,
    private snackbar: MatSnackBar
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    try {
      const queryParams = route.queryParams;
      const storedReferral = localStorage.getItem('referral');

      // If query parameter is set.
      if (queryParams['referral']) {
        const referral = await firstValueFrom(
          this.referralService.readOneByHash(queryParams['referral'])
        );
        localStorage.setItem('referral', this.stringifyToJson(referral));

        return referral;
      }

      // If stored referral is set
      if (storedReferral) {
        return this.parseJson(storedReferral);
      }

      return {};
    } catch (e) {
      return {};
    }
  }

  private stringifyToJson(object: any): string {
    try {
      return JSON.stringify(object);
    } catch (e) {
      return '';
    }
  }

  private parseJson<T>(str: string): T | Object {
    try {
      return JSON.parse(str);
    } catch (e) {
      return {};
    }
  }
}
